import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {api, downloadBlob} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type PerfilAggregates = components['schemas']['PerfilAggregatesRead']
export type PerfilDistribution = components['schemas']['DistributionRead']
export type PerfilCoverage = components['schemas']['PerfilCoverageRead']

export function usePerfilCoverage(businessId: string | undefined) {
  return useQuery({
    queryKey: ['perfil-coverage', businessId],
    queryFn: async () => (await api.get<PerfilCoverage>(`/businesses/${businessId}/perfil/completitud`)).data,
    enabled: !!businessId,
  })
}

export function usePerfilAggregates(businessId: string | undefined) {
  return useQuery({
    queryKey: ['perfil-aggregates', businessId],
    queryFn: async () => (await api.get<PerfilAggregates>(`/businesses/${businessId}/perfil/agregados`)).data,
    enabled: !!businessId,
  })
}

type ReSolicitarResult = components['schemas']['ReSolicitarPerfilTodosRead']

export function useReSolicitarPerfilTodos(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () =>
      (await api.post<ReSolicitarResult>(`/businesses/${businessId}/perfil/re-solicitar-todos`, {})).data,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['perfil-coverage', businessId]})
      queryClient.invalidateQueries({queryKey: ['perfil-aggregates', businessId]})
    },
  })
}

export async function downloadPerfilExcel(businessId: string): Promise<void> {
  await downloadBlob(`/businesses/${businessId}/perfil/export.xlsx`, 'perfil-sociodemografico.xlsx')
}
